import { postJson, postForm } from '../config/HttpClient'

export interface Zona {
  nome: string
  codigo: string
}

export interface ReservaPOS {
  codigo: string
  mesa: string
  estado: string
  numeroLugares: number
  codigoZona: string
}

export interface MesaDisponivel {
  id: number
  nomeZona: string
  zona_id: number
  nome: string
  dataCriacao: string
  codigo: string
  estado: string
}

export interface ReservaDetalhe {
  codigo: string
  idCliente: number
  cliente: string
  mesa: string
  estado: string
  criador: string
  numeroConvidados: number
}

export interface CriarReservaResultado {
  sucesso: boolean
  mensagem: string
  codigo?: string
}

class ReservaService {
  async listarZonas(page = 0): Promise<Zona[]> {
    return postJson<Zona[]>(`/api-pos/reserva-restaurante/lista-zonas-restaurante-to-pos-by-empresa?page=${page}`)
  }

  async listarReservas(page = 0): Promise<ReservaPOS[]> {
    return postJson<ReservaPOS[]>(`/api-pos/reserva-restaurante/lista-reservas-restaurante-to-pos-by-empresa?page=${page}`)
  }

  async listarMesasDisponiveis(page = 0): Promise<MesaDisponivel[]> {
    return postJson<MesaDisponivel[]>(`/api-pos/mesa-restaurante/lista-mesas-disponiveis-to-pos-by-empresa?page=${page}`)
  }

  async obterPorCodigo(codigo: string): Promise<ReservaDetalhe | null> {
    try {
      return await postJson<ReservaDetalhe>(`/api-pos/reserva-restaurante/get-by-codigo/${codigo}`)
    } catch {
      return null
    }
  }

  async criarReserva(campos: { 'mesa.codigo': string; 'cliente.id_cliente': string; data: string; numeroConvidados: string }): Promise<CriarReservaResultado> {
    const resposta = await postForm<{ type: string; msg: string; codigo?: string }>('/api-pos/reserva-restaurante/add-pos', campos)

    return { sucesso: resposta.type === 'sucesso', mensagem: resposta.msg, codigo: resposta.codigo }
  }
}

export default new ReservaService()
